import request from '@/utils/request'

export function homeExam(params) {
  return request({
    url: '/home/examList',
    method: 'get',
    params: params
  })
}

export function examDetail(id) {
  return request({
    url: '/home/examDetail/' + id,
    method: 'get'
  })
}

export function getJobForm(id) {
  return request({
    url: '/job/jobForm/' + id,
    method: 'get'
  })
}

export function signExam(data) {
  return request({
    url: '/job/saveJobForm/' + data.jobId,
    method: 'post',
    data: data.form
  })
}

// 报名表数据
export function getSignImg(id) {
  return request({
    url: '/wxapp/getFormPaper/' + id,
    method: 'get'
  })
}

// 笔试准考证数据
export function getWrittnImg(id) {
  return request({
    url: '/wxapp/getExamineeWritten/' + id,
    method: 'get'
  })
}

// 面试准考证数据
export function getInterviewImg(id) {
  return request({
    url: '/wxapp/getExamineeFace/' + id,
    method: 'get'
  })
}

// 考试成绩查询
export function getExamResult(id) {
  return request({
    url: '/user/getExamineeScore/' + id,
    method: 'get'
  })
}

export function downloadRemarkApi(id) {
  return request({
    url: '/user/setWrittenDownload/' + id,
    method: 'get'
  })
}

export function checkStatus(id) {
  return request({
    url: '/job/checkJob/' + id,
    method: 'get'
  })
}

export function getUserFormData(id) {
  return request({
    url: '/job/detailForm/' + id,
    method: 'get'
  })
}

export function updateExamForm(data) {
  return request({
    url: '/job/updateJobForm/' + data.jobId,
    method: 'post',
    data: data.form
  })
}

export function createOrder(params) {
  return request({
    url: '/order/createOrder',
    method: 'get',
    params: params
  })
}

export function getOrderCode(params) {
  return request({
    url: '/order/qrcode',
    method: 'get',
    responseType: 'blob',
    headers: {
      type: 'file'
    },
    params: params
  })
}

export function getPayStatus(params) {
  return request({
    url: '/order/getPayStatus',
    method: 'get',
    params: params
  })
}

// 取消报名
export function cancenExamSign(id) {
  return request({
    url: '/user/setCancel/' + id,
    method: 'get'
  })
}

export function uploadPhoto(data) {
  return request({
    url: '/job/uploadImages',
    method: 'post',
    data: data
  })
}
